import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { Box, Grid, Typography } from '@material-ui/core';
import { analytics } from 'firebase';

import SubHeader from '../../../../../components/Header/SubHeader.component';
import Loader from '../../../../../components/LoaderSplash/Loader.component';
import { appConfig } from '../../../../../config/app';
import { CustomEvents } from '../../../../../constants/analytics.constant';
import {
  COLLECTION_EXPIRED,
  COLLECTION_UP_TO_DATE,
} from '../../../../../constants/policies.constant';
import { useAuthDataContext } from '../../../../../context/auth/auth.provider';
import { useVehiclesContext } from '../../../../../context/vehicles/vehicles.provider';
import { dataLayerPush } from '../../../../../helpers/dataLayerPush';
import useLogEventInAnalytics from '../../../../../hooks/useLogAnalyticsEvent';
import { useTipification } from '../../../../../hooks/useTipification';
import { GetPreference } from '../../../../../services/payments/payments.service';
import Navigation from '../../Navigation/Navigation.component';

const MaturitiesDetails = () => {
  const { policy, loading, getPolicyById } = useVehiclesContext();
  const { user } = useAuthDataContext();
  const { id }: any = useParams();
  const history = useHistory();
  const [preferenceId, setPreferenceId] = useState(false);
  const { logEvent } = useLogEventInAnalytics();
  const { trackEvent, events } = useTipification();

  const setMercadoPagoPreferences = async () => {
    if (!preferenceId) {
      const body: any = {
        title: 'Pagos vencidos',
        description: 'Monto correspondiente a pagos vencidos',
        quantity: 1,
        currency_id: 'ARS',
        unit_price: policy?.financial?.mercado_pago?.maturities_amount,
        type: 'maturities',
        policy_number: policy?.number,
        payer: {
          email: user.email,
        },
      };
      const getPreferenceId = await GetPreference(body).then(
        (res) => res.data.preference_id
      );
      const script = document.createElement('script');
      script.src =
        'https://www.mercadopago.com.ar/integrations/v1/web-payment-checkout.js';
      script.async = true;
      script.setAttribute('data-preference-id', getPreferenceId);
      script.setAttribute('data-button-label', 'Pagar con Mercado Pago');
      document.getElementById('mercadoForm')!.appendChild(script);
      setPreferenceId(true);
    }
  };

  useEffect(() => {
    if (
      policy.number &&
      parseInt(policy?.financial?.mercado_pago?.maturities_amount) > 0 &&
      policy?.financial?.mercado_pago?.can_pay
    ) {
      setMercadoPagoPreferences();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [policy]);

  useEffect(() => {
    logEvent(CustomEvents.EXPIRED_PAYMENTS_VIEW, {
      app: appConfig?.NAME,
    });
  }, [logEvent]);

  useEffect(() => {
    const allowedOrigins = [
      'https://www.mercadopago.com.ar',
      'https://www.sandbox.mercadopago.com.ar',
      'https://www.mercadolibre.com',
      'https://mercadopago.com.ar',
      'https://sandbox.mercadopago.com.ar',
      'https://mercadolibre.com',
    ];

    const handleMessage = (event: MessageEvent) => {
      if (!allowedOrigins.includes(event.origin) || !event.data.type) {
        return;
      }

      const dataType = event.data.type;

      if (dataType === 'submit') {
        dataLayerPush(CustomEvents.MP_MATURITIES_PAYMENT, user?.id);
        trackEvent(events.ADVICE_DIGITAL_PAYMENT);
        logEvent(CustomEvents.MP_MATURITIES_PAYMENT, {
          app: appConfig?.NAME,
        });
        history.push('/account/payment/' + policy?.id);
        getPolicyById(id);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [events.ADVICE_DIGITAL_PAYMENT, getPolicyById, history, id, logEvent, policy, trackEvent, user]);

  const pagarMercadoPago = () => {
    dataLayerPush('mis_pagos_pagarmp', user?.id);
  };

  return (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Cargando póliza'}></Loader>
      </Box>
      {/* <Navigation /> */}
      <SubHeader
        content={
          <Box>
            <Box my={3}>
              <Typography variant="caption" color="primary">
                Póliza {policy?.number}
              </Typography>
              <Typography variant="h6" color="primary">
                Pagos pendientes
              </Typography>
            </Box>
            <Box my={2}>
              <Grid container>
                <Grid item xs={12} sm={6}>
                  {/* <Box my={2}>
                    <Typography color="primary">
                      {policy?.financial?.coverage
                        ? COLLECTION_UP_TO_DATE
                        : COLLECTION_EXPIRED}
                    </Typography>
                  </Box> */}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box my={2}>
                    <Typography display="block" variant="h6">
                      ${' '}
                      {policy?.financial?.maturities?.amount
                        ? policy?.financial?.maturities?.amount
                        : '0.00'}
                    </Typography>
                    <Typography display="block" variant="caption">
                      {policy?.payment_type_name}
                    </Typography>
                    <Typography display="block" variant="caption">
                      {policy?.payment_method || ''}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        }
        actions={
          <Box mt={4} mb={2}>
            {policy?.financial?.mercado_pago?.can_pay &&
              parseInt(policy?.financial?.mercado_pago?.maturities_amount) >
                0 && (
                /*eslint-disable-next-line no-script-url */
                <form
                  action="javascript://"
                  method="POST"
                  id="mercadoForm"
                  onClick={() => pagarMercadoPago()}
                />
              )}
          </Box>
        }
        fullActions
      ></SubHeader>
    </>
  );
};

export default MaturitiesDetails;
